import { gql } from 'graphql-request'

export namespace GroupQueries {
  export const QUERY_KEY = 'getMissionControlGroups'

  export namespace GET_GROUPS {
    export type Response = {
      groups: Group[] | null
    }
  }

  export function getMissionControlGroups() {
    return gql`
      query getMissionControlGroups($limit: Int!) {
        groups(filter: { limit: $limit }) {
          id
          name
        }
      }
    `
  }
}

export interface Group {
  id: number
  name: string
}
